import { render, staticRenderFns } from "./CTag.vue?vue&type=template&id=d288a040&scoped=true"
import script from "./CTag.vue?vue&type=script&lang=js"
export * from "./CTag.vue?vue&type=script&lang=js"
import style0 from "./CTag.vue?vue&type=style&index=0&id=d288a040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d288a040",
  null
  
)

export default component.exports